import { component } from 'picoapp'
import $ from 'quantdom'

export default component((node) => {
  const sideMenuLinks = $(node).find('.js-side-menu-link')
  const sliderLinks = $(node).find('.js-slider-link')
  const plansLinks = $(node).find('.js-plans-link')
  sideMenuLinks.each((el) => {
    el.addEventListener('click', () => {
      if (window?.gtag) {
        gtag('event', `Navigation Selection`, {
          event_detail: `${el.getAttribute('data-side-menu-link-title')}`,
        })
      }
    })
  })

  sliderLinks.each((el) => {
    el.addEventListener('click', () => {
      if (window?.gtag) {
        gtag('event', `Navigation Slider Selection`, {
          event_detail: `${el.getAttribute('data-slider-link-title')}`,
        })
      }
    })
  })

  plansLinks.each((el) => {
    el.addEventListener('click', () => {
      const planTitle = `${el.getAttribute('data-plans-link-title')}`
      window.MicroBus.emit('igEvents:push', {
        event: `Side Menu - Plans Link - Clicked - ${planTitle}`,
      })
    })
  })
})
